import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function categoryListReducer(
  state = initialState.categoryList,
  action
) {
  switch (action.type) {
    case types.LOADED_CATEGORY_LIST_SUCCESS:
      return action.categoryList;
    default:
      return state;
  }
}
